import React from 'react';
import { DashboardLeadsCharts } from './';
import { DashboardChartsProps } from './dashboardModels';
import DonutChartCard from './DonutChartCard';

const DashboardCharts: React.FC<DashboardChartsProps> = ({
  dashboardStatisticsData,
  isLoading,
  filterTitle,
}) => {
  const meetingsBooked = dashboardStatisticsData?.meetingsBooked ?? {
    value: 0,
    prevValue: 0,
  };
  const warmLeads = dashboardStatisticsData?.warmLeads ?? {
    value: 0,
    prevValue: 0,
  };
  const conversation = dashboardStatisticsData?.conversation ?? {
    value: 0,
    prevValue: 0,
  };
  const replies = dashboardStatisticsData?.replies ?? {
    value: 0,
    prevValue: 0,
  };

  return (
    <div className="d-flex-row w-100 h-18rem bg-white  mt-1_875rem b-radius-1_25rem">
      <DashboardLeadsCharts
        dashboardStatisticsData={dashboardStatisticsData ?? null}
        isLoading={isLoading}
      />
      <DonutChartCard
        isLoading={isLoading}
        value={meetingsBooked?.value}
        prevValue={meetingsBooked.prevValue}
        title="Meetings Booked"
        label="Booked"
        tooltipText="How many appointments have been successfully scheduled from your campaigns."
        colors={['#620AF0', '#B38AF5']}
        textColor="c-8c4df3"
        filterTitle={filterTitle}
      />
      <DonutChartCard
        isLoading={isLoading}
        value={warmLeads?.value}
        prevValue={warmLeads.prevValue}
        title="Warm Leads"
        label="Leads"
        tooltipText="Leads that showed interest by clicking a link or engaging but haven’t booked yet."
        colors={['#F00A0A', '#F58A8A']}
        textColor="c-f34d4d"
        filterTitle={filterTitle}
      />
      <DonutChartCard
        isLoading={isLoading}
        value={conversation?.value}
        prevValue={conversation.prevValue}
        title="Conversations Sent"
        label="Sent"
        tooltipText="Number of messages Astreaux has sent to engage leads."
        colors={['#0AB9F0', '#8AEFF5']}
        textColor="c-4dd5f3"
        filterTitle={filterTitle}
      />
      <DonutChartCard
        isLoading={isLoading}
        value={replies.value}
        prevValue={replies.prevValue}
        title="Replies"
        label="Replies"
        tooltipText="How many leads responded to your outreach messages."
        colors={['#74CD94', '#C2FBA5']}
        textColor="c-47ac34"
        filterTitle={filterTitle}
      />
    </div>
  );
};

export default DashboardCharts;
